import { createFileRoute } from '@tanstack/react-router'
import MoveProjectModal from '../../../../../../../containers/project-menu/components/move-items-modals/move-project-modal'
import { moveProjectSearchSchema } from '../../../search-schemas'

export const Route = createFileRoute(
  '/_authenticated/project/_projects/move/project/$projectId/'
)({
  validateSearch: moveProjectSearchSchema,
  component: MoveProjectModal
})
